import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { getInboxChannelsTableUrl } from '../inboxSettingsUrls';
// @ts-expect-error module not typed

import { localStorage } from 'conversations-platform/localStorage';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function UnauthenticatedDomainsPrompt({
  inboxId,
  isAdmin,
  unauthorizedAccounts
}) {
  const localStorageKey = `LocalSettings:${inboxId}:unauthenticated-domains-prompt-dismissed`;
  const connectedAccountsWithUnauthenticatedDomainsCount = unauthorizedAccounts && unauthorizedAccounts.length;
  const hasUnauthenticatedDomains = !!connectedAccountsWithUnauthenticatedDomainsCount;
  const [isDismissed, setIsDismissed] = useState(!!localStorage.getItem(localStorageKey));
  const hidePrompt = isDismissed || !hasUnauthenticatedDomains;
  if (hidePrompt) {
    return null;
  }
  const goToDomainsLink = getInboxChannelsTableUrl({
    inboxId: inboxId
  });
  return /*#__PURE__*/_jsxs(Alert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "svh-workspace-ui-lib.unauthenticated-domains.title",
      options: {
        count: connectedAccountsWithUnauthenticatedDomainsCount
      }
    }),
    closeable: true,
    onClose: () => {
      setIsDismissed(true);
      localStorage.setItem(localStorageKey, 'true');
    },
    children: [isAdmin ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "svh-workspace-ui-lib.unauthenticated-domains.admin-details"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "svh-workspace-ui-lib.unauthenticated-domains.rep-details"
    }), ' ', /*#__PURE__*/_jsx(Link, {
      href: "https://knowledge.hubspot.com/email/manage-your-email-authentication-in-hubspot",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.unauthenticated-domains.learn-more"
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "tertiary",
      target: "_blank",
      external: true,
      href: goToDomainsLink,
      size: "extra-small",
      marginInline: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.unauthenticated-domains.button"
      })
    })]
  });
}
UnauthenticatedDomainsPrompt.displayName = 'UnauthenticatedDomainsPrompt';